import { chain } from 'lodash';

export const sortedDestinationsWithIcons = (
  allDestinations,
  language,
  specialRegions,
) => chain(allDestinations)
  .sort((a, b) => {
    const nameKey = `name${language.toUpperCase()}`;
    const aKey = specialRegions[a.code]
      ? specialRegions[a.code].sortLabel
      : a.country[nameKey];
    const bKey = specialRegions[b.code]
      ? specialRegions[b.code].sortLabel
      : b.country[nameKey];

    if (aKey > bKey) {
      return 1;
    }
    if (aKey < bKey) {
      return -1;
    }
    return 0;
  })
  .value();

export const groupedDestinations = (regions, destinationsWithIcons) => chain(destinationsWithIcons)
  .groupBy((dest) => (regions[dest.code] ? 'special' : 'ordinary'))
  .map((group) => ({ options: group }))
  .value();
